import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ConfigProvider } from "@/context/ConfigContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Agenda from "@/pages/Agenda";
import Pacientes from "@/pages/Pacientes";
import PacienteDetalle from "@/pages/PacienteDetalle";
import Pagos from "@/pages/Pagos";
import LibroCaja from "@/pages/LibroCaja";
import Profesionales from "@/pages/Profesionales";
import Historial from "@/pages/Historial";
import ConfirmarTurno from "@/pages/ConfirmarTurno";
import Ajustes from "@/pages/Ajustes";
import InstallPrompt from "@/components/InstallPrompt";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-neutral-500 text-sm">
        Cargando…
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user || user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ConfigProvider>
          <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <InstallPrompt />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/confirmar/:token" element={<ConfirmarTurno />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="agenda" element={<Agenda />} />
              <Route path="pacientes" element={<Pacientes />} />
              <Route path="pacientes/:id" element={<PacienteDetalle />} />
              <Route path="historial" element={<Historial />} />
              <Route path="pagos" element={<Pagos />} />
              <Route path="caja" element={<LibroCaja />} />
              <Route
                path="profesionales"
                element={
                  <AdminOnly>
                    <Profesionales />
                  </AdminOnly>
                }
              />
              <Route
                path="ajustes"
                element={
                  <AdminOnly>
                    <Ajustes />
                  </AdminOnly>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
        </ConfigProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
